import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Form from './Form';
import { getPosts } from '../actions/action';
import Meta from './Meta';
import Result from './Result';
import PropTypes from 'prop-types';

class Search extends Component {

    // 新規アクセスがきた場合
    componentWillMount = () => {
        const params = new URLSearchParams(this.props.location.search);
        const keywords = (params.get('Keywords') ? params.get('Keywords') : '');
        const sort = (params.get('sort') ? params.get('sort') : '');
        const start = (params.get('start') ? params.get('start') : '');

        this.setState({
            keywords: keywords,
            sort: sort,
            start: start
        });
        this.props.getPosts(keywords, sort, start);
    };

    // URLが変更された場合
    componentWillReceiveProps = nextProps => {
        if (nextProps.location !== this.props.location) {
            const params = new URLSearchParams(nextProps.location.search);
            const keywords = (params.get('Keywords') ? params.get('Keywords') : '');
            const sort = (params.get('sort') ? params.get('sort') : '');
            const start = (params.get('start') ? params.get('start') : '');
            
            this.setState({
                keywords: keywords,
                sort: sort,
                start: start
            });
            this.props.getPosts(keywords, sort, start);
        }
    };
    
    render() {
        let shimenUrl = encodeURI(`http://digital.asahi.com/article_search/list.html?iref=pc_articletab&keyword=${this.state.keywords}`);
        return (
        <>
        <Meta word={this.state.keywords} sort={this.state.sort} start={this.state.start} />
        <div className="Section">
            <div className="SearchTab">
                <ul>
                    <li className="tabWeb"><div className="title"><span className="tabSub">サイト内記事検索</span></div></li>
                    <li className="tabShimbun"><a href={shimenUrl}><span className="tabLink">新聞記事検索</span></a></li>
                </ul>
            </div>
        </div>

        {/* 検索窓 Form */}
        <Form keywords={this.state.keywords} sort={this.state.sort} push={this.props.push} />

        {/* 検索結果 */}
        <Result />                
        </>
        );
    }
}

function mapStateToProps(state) {
    return {
        keywords: state.keywords,
        sort: state.sort,
        start: state.start
    }
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        push: (keywords, sort, start) => {
            const { location, history } = ownProps;
            const params = new URLSearchParams(location.search);

            params.set('Keywords', keywords);
            params.set('sort', sort);
            if ( typeof start !== "undefined" ) params.set('start', start);
            params.set('iref', 'pc_ss_date_search');

            history.push({
                search: params.toString(),
            });
        },
        getPosts: (keywords, sort, start) => {
            dispatch(getPosts(keywords, sort, start));
        },
    }
}

Search.propTypes = {
    keywords: PropTypes.string,
    sort: PropTypes.string,
    start: PropTypes.string,
    push: PropTypes.func.isRequired,
    getPosts: PropTypes.func.isRequired,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));
